import React from 'react';
import styled from 'styled-components';
import { FieldError, FieldValues, UseFormRegister } from 'react-hook-form';

import { sizing } from '@/styles/theme';
import { Checkbox } from './Checkbox';

interface IFormCheckboxGroup {
  label: string;
  register?: UseFormRegister<FieldValues>;
  checkboxes: {
    name: string;
    label: string;
    value: string;
  }[];
  error?: FieldError;
  touched?: boolean;
  className?: string;
  type?: 'checkbox' | 'radio';
}

const CheckboxGroup = (props: IFormCheckboxGroup): React.ReactElement => {
  const { label, checkboxes, register, className, error, touched, type } = props;

  return (
    <Fieldset className={className}>
      <InputContainer>
        <InputLabel className="group-label">{label}</InputLabel>
        <CheckboxContainer>
          {checkboxes.map(checkbox => (
            <Checkbox
              className="checkbox-item"
              key={`${checkbox.name}-${checkbox.value}`}
              id={`${checkbox.name}-${checkbox.value}`}
              name={checkbox.name}
              label={checkbox.label}
              value={checkbox.value}
              register={register}
              type={type}
              isStandalone={false}
            />
          ))}
        </CheckboxContainer>
      </InputContainer>
      <ErrorMessage className="error-message">
        {(error && touched) || error?.type === 'api' ? error.message : ''}
      </ErrorMessage>
    </Fieldset>
  );
};

export { CheckboxGroup };

const Fieldset = styled.fieldset`
  font-size: ${sizing.fontSize.sm};
  padding: 12px 0;
`;

const InputLabel = styled.label`
  font-size: 16px;
  color: #374151;
  line-height: 24px;
  margin-bottom: 0.25rem;
`;

const InputContainer = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
`;

const CheckboxContainer = styled.div`
  display: flex;
  gap: 30px;
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  line-height: 12px;
  height: 24px;
  padding-top: 4px;
  color: #dc3545;
`;
